<template>
    <aside id="sidebar_left" class="nano nano-light affix">

        <div class="scroll-menu-left">
            <div class="sidebar-left-content nano-content">

                <ul class="nav sidebar-menu">

                    <li class="sidebar-label pt20" v-if="menu.defaults.filter((menu) => $store.state.user.me.can(menu.role)).length > 0">Основные</li>
                    <li v-for="(main, mainIndex) in menu.defaults.filter((menu) => $store.state.user.me.can(menu.role))" v-bind:key="'default-' + mainIndex">

                        <router-link v-if="!main.children" class="accordion-toggle" :to="main.route" :title="main.title">
                            <span :class="main.icon"></span>
                            <span class="sidebar-title">{{ main.title }}</span>
                            <span v-if="main.route.name === 'bids-list'" class="ml5 badge bid_badge label-danger">{{$store.state.template.bidCount}}</span>
                        </router-link>
                        <a v-if="main.children" href="#" class="accordion-toggle" :class="{ 'menu-open': main.isOpen === true }" @click.prevent="openMenuClick(main)">
                            <span :class="main.icon"></span>
                            <span class="sidebar-title">{{ main.title }}</span>
                            <span class="caret"></span>
                        </a>
                        <ul class="nav sub-nav" v-if="main.children">
                            <li v-for="(children, index) in main.children.filter((menu) => $store.state.user.me.can(menu.role))" v-bind:key="index">
                                <router-link :to="children.route" :title="children.title">
                                    <span :class="children.icon"></span>
                                    {{children.title}}
                                </router-link>
                            </li>
                        </ul>
                    </li>

                    <li class="sidebar-label pt20" v-if="menu.schedule.filter((menu) => $store.state.user.me.can(menu.role)).length > 0">Расписание</li>
                    <li v-for="(main, mainIndex) in menu.schedule.filter((menu) => $store.state.user.me.can(menu.role))" v-bind:key="'schedule-' + mainIndex">

                        <router-link v-if="!main.children" class="accordion-toggle" :to="main.route" :title="main.title">
                            <span :class="main.icon"></span>
                            <span class="sidebar-title">{{ main.title }}</span>
                        </router-link>
                        <a v-if="main.children" href="#" class="accordion-toggle" :class="{ 'menu-open': main.isOpen === true }" @click.prevent="openMenuClick(main)">
                            <span :class="main.icon"></span>
                            <span class="sidebar-title">{{ main.title }}</span>
                            <span class="caret"></span>
                        </a>
                        <ul class="nav sub-nav" v-if="main.children">
                            <li v-for="(children, index) in main.children.filter((menu) => $store.state.user.me.can(menu.role))" v-bind:key="index">
                                <router-link :to="children.route" :title="children.title">
                                    <span :class="children.icon"></span>
                                    {{children.title}}
                                </router-link>
                            </li>
                        </ul>
                    </li>

                    <li class="sidebar-label pt20" v-if="menu.clients.filter((menu) => $store.state.user.me.can(menu.role)).length > 0">Клиенты</li>
                    <li v-for="(main, mainIndex) in menu.clients.filter((menu) => $store.state.user.me.can(menu.role))" v-bind:key="'client-' + mainIndex">

                        <router-link v-if="!main.children" class="accordion-toggle" :to="main.route" :title="main.title">
                            <span :class="main.icon"></span>
                            <span class="sidebar-title">{{ main.title }}</span>
                        </router-link>
                        <a v-if="main.children" href="#" class="accordion-toggle" :class="{ 'menu-open': main.isOpen === true }" @click.prevent="openMenuClick(main)">
                            <span :class="main.icon"></span>
                            <span class="sidebar-title">{{ main.title }}</span>
                            <span class="caret"></span>
                        </a>
                        <ul class="nav sub-nav" v-if="main.children">
                            <li v-for="(children, index) in main.children.filter((menu) => $store.state.user.me.can(menu.role))" v-bind:key="index">
                                <router-link :to="children.route" :title="children.title">
                                    <span :class="children.icon"></span>
                                    {{children.title}}
                                </router-link>
                            </li>
                        </ul>
                    </li>

                    <li class="sidebar-label pt20" v-if="menu.events.filter((menu) => $store.state.user.me.can(menu.role)).length > 0">События</li>
                    <li v-for="(main, mainIndex) in menu.events.filter((menu) => $store.state.user.me.can(menu.role))" v-bind:key="'event-' + mainIndex">

                        <router-link v-if="!main.children" class="accordion-toggle" :to="main.route" :title="main.title">
                            <span :class="main.icon"></span>
                            <span class="sidebar-title">{{ main.title }}</span>
                        </router-link>
                        <a v-if="main.children" href="#" class="accordion-toggle" :class="{ 'menu-open': main.isOpen === true }" @click.prevent="openMenuClick(main)">
                            <span :class="main.icon"></span>
                            <span class="sidebar-title">{{ main.title }}</span>
                            <span class="caret"></span>
                        </a>
                        <ul class="nav sub-nav" v-if="main.children">
                            <li v-for="(children, index) in main.children.filter((menu) => $store.state.user.me.can(menu.role))" v-bind:key="index">
                                <router-link :to="children.route" :title="children.title">
                                    <span :class="children.icon"></span>
                                    {{children.title}}
                                </router-link>
                            </li>
                        </ul>
                    </li>

                    <li class="sidebar-label pt20" v-if="menu.reports.filter((menu) => $store.state.user.me.can(menu.role)).length > 0">Отчеты</li>
                    <li v-for="(main, mainIndex) in menu.reports.filter((menu) => $store.state.user.me.can(menu.role))" v-bind:key="'reports-' + mainIndex">

                        <router-link v-if="!main.children" class="accordion-toggle" :to="main.route" :title="main.title">
                            <span :class="main.icon"></span>
                            <span class="sidebar-title">{{ main.title }}</span>
                        </router-link>
                        <a v-if="main.children" href="#" class="accordion-toggle" :class="{ 'menu-open': main.isOpen === true }" @click.prevent="openMenuClick(main)">
                            <span :class="main.icon"></span>
                            <span class="sidebar-title">{{ main.title }}</span>
                            <span class="caret"></span>
                        </a>
                        <ul class="nav sub-nav" v-if="main.children">
                            <li v-for="(children, index) in main.children.filter((menu) => $store.state.user.me.can(menu.role))" v-bind:key="index">
                                <router-link :to="children.route" :title="children.title">
                                    <span :class="children.icon"></span>
                                    {{children.title}}
                                </router-link>
                            </li>
                        </ul>
                    </li>

                    <li class="sidebar-label pt20" v-if="menu.communications.filter((menu) => $store.state.user.me.can(menu.role)).length > 0">Коммуникации</li>
                    <li v-for="(main, mainIndex) in menu.communications.filter((menu) => $store.state.user.me.can(menu.role))" v-bind:key="'communications-' + mainIndex">

                        <router-link v-if="!main.children" class="accordion-toggle" :to="main.route" :title="main.title">
                            <span :class="main.icon"></span>
                            <span class="sidebar-title">{{ main.title }}</span>
                        </router-link>
                        <a v-if="main.children" href="#" class="accordion-toggle" :class="{ 'menu-open': main.isOpen === true }" @click.prevent="openMenuClick(main)">
                            <span :class="main.icon"></span>
                            <span class="sidebar-title">{{ main.title }}</span>
                            <span class="caret"></span>
                        </a>
                        <ul class="nav sub-nav" v-if="main.children">
                            <li v-for="(children, index) in main.children.filter((menu) => $store.state.user.me.can(menu.role))" v-bind:key="index">
                                <router-link :to="children.route" :title="children.title">
                                    <span :class="children.icon"></span>
                                    {{children.title}}
                                </router-link>
                            </li>
                        </ul>
                    </li>

                    <li class="sidebar-label pt20" v-if="menu.objects.filter((menu) => $store.state.user.me.can(menu.role)).length > 0">Объекты</li>
                    <li v-for="(main, mainIndex) in menu.objects.filter((menu) => $store.state.user.me.can(menu.role))" v-bind:key="'objects-' + mainIndex">

                        <router-link v-if="!main.children" class="accordion-toggle" :to="main.route" :title="main.title">
                            <span :class="main.icon"></span>
                            <span class="sidebar-title">{{ main.title }}</span>
                        </router-link>
                        <a v-if="main.children" href="#" class="accordion-toggle" :class="{ 'menu-open': main.isOpen === true }" @click.prevent="openMenuClick(main)">
                            <span :class="main.icon"></span>
                            <span class="sidebar-title">{{ main.title }}</span>
                            <span class="caret"></span>
                        </a>
                        <ul class="nav sub-nav" v-if="main.children">
                            <li v-for="(children, index) in main.children.filter((menu) => $store.state.user.me.can(menu.role))" v-bind:key="index">
                                <router-link :to="children.route" :title="children.title">
                                    <span :class="children.icon"></span>
                                    {{children.title}}
                                </router-link>
                            </li>
                        </ul>
                    </li>

                </ul>

                <div class="sidebar-toggle-mini">
                    <a href="#" @click.prevent="logout">
                        <span class="fa fa-sign-out"></span>
                    </a>
                </div>

            </div>

        </div>
    </aside>
</template>

<script>
    import Auth from "../classes/Auth";
    import Filiation from "../classes/api/Filiation";

    export default {
        watch: {
            '$route': function() {
                this.openMenu();
            },
            '$store.state.user.meIsLoaded': function() {
                this.fillScheduleMenu();
            },
        },
        async beforeMount() {

            this.openMenu();
        },
        data() {
            return {
                menu: {
                    defaults: [
                        {
                            title: 'Dashboard',
                            icon: 'glyphicon glyphicon-dashboard',
                            route: {name: 'dashboard'},
                            isOpen: false,
                            role: 'any',
                        },
                        {
                            title: 'Заявки',
                            icon: 'glyphicon glyphicon-comment',
                            route: {name: 'bids-list'},
                            isOpen: false,
                            role: 'manager',
                        },
                        {
                            title: 'Задачи',
                            icon: 'glyphicon glyphicon-tasks',
                            route: {name: 'tasks-list'},
                            isOpen: false,
                            role: 'manager',
                        },
                        {
                            title: 'Записи на завтра',
                            icon: 'glyphicon glyphicon-ok',
                            route: {name: 'visits-tomorrow-list'},
                            isOpen: false,
                            role: 'manager',
                        },
                    ],
                    schedule: [],
                    clients: [
                        {
                            title: 'Добавить нового',
                            icon: 'glyphicon glyphicon-plus-sign',
                            route: {name: 'clients-add'},
                            isOpen: false,
                        },
                        {
                            title: 'Список',
                            icon: 'glyphicon glyphicon-list-alt',
                            route: {name: 'clients-list'},
                            isOpen: false,
                        },
                        {
                            title: 'Абонементы',
                            icon: 'glyphicon glyphicon-credit-card',
                            route: {name: 'clients-subscription-list'},
                            isOpen: false,
                        },
                    ],
                    events: [
                        {
                            title: 'Cashflow',
                            icon: 'fa fa-money',
                            route: {name: 'cashflow'},
                            role: 'manager',
                            isOpen: false,
                            children: [
                                {
                                    title: 'Список',
                                    icon: 'glyphicon glyphicon-th-list',
                                    route: {name: 'cashflow-list'},
                                },
                                // {
                                //     title: 'Внесение в кассу',
                                //     icon: 'glyphicon glyphicon-plus-sign',
                                //     route: {name: 'cashflow-gain'},
                                // },
                                {
                                    title: 'Изъятие из кассы',
                                    icon: 'glyphicon glyphicon-minus-sign',
                                    route: {name: 'cashflow-less'},
                                },
                            ],
                        },
                    ],
                    communications: [
                        {
                            title: 'Список SMS',
                            icon: 'glyphicon glyphicon-envelope',
                            route: {name: 'sms-list'},
                            isOpen: false,
                            role: 'admin',
                        },
                        {
                            title: 'Список звонков',
                            icon: 'glyphicon glyphicon-earphone',
                            route: {name: 'calls-list'},
                            isOpen: false,
                            role: 'admin',
                        },
                    ],
                    reports: [
                        {
                            title: 'Прогульщики',
                            icon: 'glyphicon glyphicon-list-alt',
                            route: {name: 'report-no-visit-clients'},
                            isOpen: false,
                            role: 'admin',
                        },
                        {
                            title: 'Клиенты ходившие последние N дней',
                            icon: 'glyphicon glyphicon-list-alt',
                            route: {name: 'report-with-visit-clients'},
                            isOpen: false,
                            role: 'admin',
                        },
                        {
                            title: 'Инструкторы',
                            icon: 'glyphicon glyphicon-list-alt',
                            route: {name: 'report-trainer-salary'},
                            isOpen: false,
                            role: 'admin',
                        },
                        {
                            title: 'Эффективность преподавателей',
                            icon: 'glyphicon glyphicon-list-alt',
                            route: {name: 'report-trainer-efficiency'},
                            isOpen: false,
                            role: 'admin',
                        },
                        {
                            title: 'Эффективность групп',
                            icon: 'glyphicon glyphicon-list-alt',
                            route: {name: 'report-group-efficiency'},
                            isOpen: false,
                            role: 'admin',
                        },
                        {
                            title: 'Эффективность администраторов',
                            icon: 'glyphicon glyphicon-list-alt',
                            route: {name: 'report-admin-efficiency'},
                            isOpen: false,
                            role: 'admin',
                        },
                        {
                            title: 'Источники клиентов',
                            icon: 'glyphicon glyphicon-list-alt',
                            route: {name: 'report-client-source'},
                            isOpen: false,
                            role: 'admin',
                        },
                        {
                            title: 'Финансы за период',
                            icon: 'glyphicon glyphicon-list-alt',
                            route: {name: 'report-cashflow-info'},
                            isOpen: false,
                            role: 'admin',
                        },
                        {
                            title: 'Время между первой и последней покупкой',
                            icon: 'glyphicon glyphicon-list-alt',
                            route: {name: 'report-average-duration-between-sale'},
                            isOpen: false,
                            role: 'admin',
                        },
                        {
                          title: 'Время между первым и последним визитом',
                          icon: 'glyphicon glyphicon-list-alt',
                          route: {name: 'report-average-duration-between-visit'},
                          isOpen: false,
                          role: 'admin',
                        },
                        {
                            title: 'Клиенты по источникам',
                            icon: 'glyphicon glyphicon-list-alt',
                            route: {name: 'report-client-by-source'},
                            isOpen: false,
                            role: 'admin',
                        },
                      {
                        title: 'Проданные посещения',
                        icon: 'glyphicon glyphicon-list-alt',
                        route: {name: 'report-sale-week-info'},
                        isOpen: false,
                        role: 'admin',
                      },
                    ],
                    objects: [
                        {
                            title: 'Компании',
                            icon: 'glyphicon glyphicon-briefcase',
                            route: {name: 'companies'},
                            role: 'developer',
                            isOpen: false,
                            children: [
                                {
                                    title: 'Список компаний',
                                    icon: 'glyphicon glyphicon-th-list',
                                    route: {name: 'companies-list'},
                                },
                                {
                                    title: 'Новая компания',
                                    icon: 'glyphicon glyphicon-plus-sign',
                                    route: {name: 'companies-add'},
                                },
                            ],
                        },
                        {
                            title: 'Направления',
                            icon: 'glyphicon glyphicon-fullscreen',
                            route: {name: 'directions'},
                            role: 'admin',
                            isOpen: false,
                            children: [
                                {
                                    title: 'Список направлений',
                                    icon: 'glyphicon glyphicon-th-list',
                                    route: {name: 'directions-list'},
                                },
                                {
                                    title: 'Новое направление',
                                    icon: 'glyphicon glyphicon-plus-sign',
                                    route: {name: 'directions-add'},
                                },
                                {
                                    title: 'Список схем выплат',
                                    icon: 'fa fa-columns',
                                    route: {name: 'salary-scheme-list'},
                                },
                            ],
                        },
                        {
                            title: 'Абонементы',
                            icon: 'glyphicon glyphicon-shopping-cart',
                            route: {name: 'subscriptions'},
                            role: 'manager',
                            isOpen: false,
                            children: [
                                {
                                    title: 'Список абонементов',
                                    icon: 'glyphicon glyphicon-th-list',
                                    route: {name: 'subscriptions-list'},
                                },
                                {
                                    title: 'Новый абонемент',
                                    icon: 'glyphicon glyphicon-plus-sign',
                                    route: {name: 'subscriptions-add'},
                                },
                            ],
                        },
                        {
                            title: 'Товары',
                            icon: 'fa fa-cube',
                            route: {name: 'catalog'},
                            role: 'manager',
                            isOpen: false,
                            children: [
                                {
                                    title: 'Список товаров',
                                    icon: 'glyphicon glyphicon-th-list',
                                    route: {name: 'catalog-list'},
                                },
                                {
                                    title: 'Новый товар',
                                    icon: 'glyphicon glyphicon-plus-sign',
                                    route: {name: 'catalog-good-add'},
                                },
                            ],
                        },
                        {
                            title: 'Филиалы',
                            icon: 'glyphicon glyphicon-tower',
                            route: {name: 'filiations'},
                            isOpen: false,
                            role: 'admin',
                            children: [
                                {
                                    title: 'Список филиалов',
                                    icon: 'glyphicon glyphicon-th-list',
                                    route: {name: 'filiations-list'},
                                },
                                {
                                    title: 'Новый филиал',
                                    icon: 'glyphicon glyphicon-plus-sign',
                                    route: {name: 'filiations-add'},
                                },
                            ],
                        },
                        {
                            title: 'Залы',
                            icon: 'glyphicon glyphicon-modal-window',
                            route: {name: 'fitness-rooms'},
                            isOpen: false,
                            role: 'admin',
                            children: [
                                {
                                    title: 'Список залов',
                                    icon: 'glyphicon glyphicon-th-list',
                                    route: {name: 'fitness-rooms-list'},
                                },
                                {
                                    title: 'Новый зал',
                                    icon: 'glyphicon glyphicon-plus-sign',
                                    route: {name: 'fitness-rooms-add'},
                                },
                            ],
                        },
                        {
                            title: 'Инструкторы',
                            icon: 'fa fa-diamond',
                            route: {name: 'trainers'},
                            isOpen: false,
                            role: 'admin',
                            children: [
                                {
                                    title: 'Список инструкторов',
                                    icon: 'glyphicon glyphicon-th-list',
                                    route: {name: 'trainers-list'},
                                },
                                {
                                    title: 'Новый инструктор',
                                    icon: 'glyphicon glyphicon-plus-sign',
                                    route: {name: 'trainers-add'},
                                },
                            ],
                        },
                        {
                          title: 'Параметры',
                          icon: 'glyphicon glyphicon-compressed',
                          route: {name: 'parameters-edit'},
                          isOpen: false,
                          role: 'admin',
                        },
                        {
                            title: 'Пользователи',
                            icon: 'glyphicon glyphicon-user',
                            route: {name: 'users'},
                            isOpen: false,
                            role: 'admin',
                            children: [
                                {
                                    title: 'Список пользователей',
                                    icon: 'glyphicon glyphicon-th-list',
                                    route: {name: 'users-list'},
                                },
                                {
                                    title: 'Новый пользователь',
                                    icon: 'glyphicon glyphicon-plus-sign',
                                    route: {name: 'users-add'},
                                },
                            ],
                        },
                    ],
                },
            };
        },
        methods: {
            openMenu() {
                for (let groupName in this.menu) {
                    for (let menuIndex in this.menu[groupName]) {
                        this.menu[groupName][menuIndex].isOpen = this.$route.matched.some(record => {
                            return record.name === this.menu[groupName][menuIndex].route.name && record.path !== '';
                        });
                    }
                }
            },
            openMenuClick(menu) {
                for (let groupName in this.menu) {
                    for (let menuIndex in this.menu[groupName]) {
                        this.menu[groupName][menuIndex].isOpen = false;
                    }
                }

                menu.isOpen = true;
            },

            logout() {
                Auth.logout();
                this.$store.commit('user/clear');
                this.$router.push({
                    name: 'login',
                    query: {
                        redirect: this.$route.fullPath
                    },
                })
            },

            async fillScheduleMenu() {
                this.menu.schedule = [];
                const filiationsResponse = await Filiation.getList(1, 999);

                for (let filiation of filiationsResponse.data) {
                    if (this.$store.state.user.me.role === 'manager' && this.$store.state.user.me.filiationId !== Number(filiation.id)) {
                        continue;
                    }
                    this.menu.schedule.push({
                        title: filiation.name,
                        icon: 'fa fa-calendar',
                        route: {name: 'schedule-list', params: {id: filiation.id}},
                        isOpen: false,
                    });
                }

                this.menu.schedule.push({
                    title: 'Группы',
                    icon: 'fa fa-users',
                    route: {name: 'schedule-groups'},
                    isOpen: false,
                    role: 'admin',
                    children: [
                        {
                            title: 'Список групп',
                            icon: 'glyphicon glyphicon-th-list',
                            route: {name: 'schedule-group-list'},
                        },
                        {
                            title: 'Новая группа',
                            icon: 'glyphicon glyphicon-plus-sign',
                            route: {name: 'schedule-group-add'},
                        },
                    ],
                });

                this.openMenu();
            },
        },
    }
</script>
